const pageTableStyles = (theme) => ({
  root: {
    width: '100%',
    height: 'calc(100vh - 64px)',
    '& .MuiButton-root': {
      fontSize: '1.1rem',
    },
  },
  table: {
    minWidth: 780,
    '& th': {
      fontSize: '1rem',
      whiteSpace: 'nowrap',
    },
    '& th': {
      whiteSpace: 'nowrap',
    },
  },
  tableWrapper: {
    overflowX: 'auto',
    border: '1px solid #ccc',
    maxHeight: 'calc(100vh - 128px)',
  },
  clickableCell: {
    cursor: 'pointer',
    '&:hover': {
      textDecoration: 'underline',
    },
  },
  messageCell: {
    width: '35%',
  },
  colLatestContact: {},
});

export default pageTableStyles;
